import { BlogSection } from "@/types/blog";

export const technologie: BlogSection = {
  id: "technologie-mit-mass",
  title: "Technologie mit Maß einsetzen",
  content: `
    <p>Digitale Werkzeuge können unterstützen. Sie strukturieren Abläufe und sparen Zeit.</p>

    <p>Aber sie ersetzen keine Beziehung, kein Urteil, keine Empathie.</p>

    <p>Gerade dort, wo Menschen miteinander arbeiten oder Kunden betreuen, bleibt der Mensch entscheidend. Technik ist Unterstützung, nicht Zentrum von Führung.</p>
  `
};
